// frontend/src/api/inventory.js
import { apiClient } from './index';

const inventoryApi = {
  /**
   * Get ALL parts (Admin only)
   */
  getAllPartsAdmin: async () => {
    return await apiClient.get('/inventory/');
  },

  /**
   * Get Inventory Statistics (Value, Low Stock)
   */
  getInventoryStats: async () => {
    return await apiClient.get('/inventory/stats');
  },

  /**
   * Create a new part (Admin only)
   * @param {Object} partData 
   */
  createPart: async (partData) => {
    return await apiClient.post('/inventory/', partData);
  },

  /**
   * Update an existing part (Admin only)
   * @param {string} partId 
   * @param {Object} partData 
   */
  updatePart: async (partId, partData) => {
    return await apiClient.put(`/inventory/${partId}`, partData);
  },

  /**
   * Update part status (Approve/Reject)
   * @param {string} partId 
   * @param {string} status 
   */
  updatePartStatus: async (partId, status) => {
    return await apiClient.put(`/inventory/${partId}/status`, { status });
  },

  /**
   * Delete a part (Admin only)
   * @param {string} partId 
   */
  deletePart: async (partId) => {
    return await apiClient.delete(`/inventory/${partId}`);
  }
};

export { inventoryApi };